import React from "react";
import "./About.css";
import {Link} from 'react-router-dom'
const SectionOne = () => {
  return (
    <>
      <div className="about-sec overflow-hidden space-top" id="about-sec">
        <div className="container">
          <div className="row">
            {/* <div
              className="col-xl-6 wow fadeInLeft"
              style={{ visibility: "visible", animationName: "fadeInLeft" }}
            >
              <div className="img-box1">
                <div className="img1">
                  <img
                    className="tilt-active about-us-first-imggg"
                    src="https://html.themeholy.com/rasm/demo/assets/img/normal/about_1.jpg"
                    alt="About"
              
                  />
                </div>
                <div className="img2">
                  <img
                    className="tilt-active"
                    src="https://html.themeholy.com/rasm/demo/assets/img/normal/about_2.jpg"
                    alt="About"
                    style={{
                      willChange: "transform",
                      transform:
                        "perspective(1000px) rotateX(0deg) rotateY(0deg)",
                      width: "400px",
                      height: "350px",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="img3">
                  <img
                    src="https://html.themeholy.com/rasm/demo/assets/img/shape/flower_1_3.png"
                    alt="About"
                  />
                </div>
              </div>
            </div> */}
            <div className="col-xl-6">
              <div
                className="ps-xl-4 wow fadeInRight"
                style={{ visibility: "visible", animationName: "fadeInRight" }}
              >
                <div className="title-area mb-25">
                  <span className="sub-title">About Us</span>
                  <h2 className="sec-title mb-20">
                    Best Plastic Surgery Center in India
                  </h2>
                  <p className="mb-30">
                    Surgery Saathi, is
                    your trusted partner in surgical care. Located in Gurugram,
                    we specialize in a variety of procedures, offering
                    personalized support tailored to your unique needs. Our
                    clinic combines the latest medical advancements with a
                    compassionate approach, ensuring exceptional outcomes and
                    prioritizing your safety. From your initial consultation to
                    post-operative care, we are dedicated to making your
                    experience seamless and reassuring. Our skilled team is here
                    to answer your questions and provide the support you need at
                    every step. At Surgery Saathi, your well-being is our top
                    priority, and we are committed to delivering the highest
                    standards of care to enhance your health and confidence.
                  </p>
                </div>

                {/* <div className="video-group text-center"> */}
                <Link
                  className="th-btn style2"
                  style={{
                    background: "#0f80a5",
                    padding: "15px",
                    textAlign: "end",
                  }}
                  to="tel:+918882852726"
                >
                  Make A Call
                  <i className="fa-regular fa-arrow-right ms-2" />
                </Link>
                {/* </div> */}
              </div>
            </div>
            <div
              className="col-xl-6 wow fadeInLeft"
              style={{ visibility: "visible", animationName: "fadeInLeft" }}
            >
              <div className="img-box1">
                <div className="img1">
                  <img
                    className="tilt-active about-us-first-imggg"
                    src="https://img.freepik.com/premium-photo/hands-cosmetologist-making-preparation-face-contouring-plasty_152637-676.jpg?w=900"
                    alt="About"
                  />
                </div>
                <div className="img2">
                  <img
                    className="tilt-active"
                    src="https://img.freepik.com/premium-photo/cosmetology-hardware-treatment-by-microcurrents_88340-1122.jpg?w=900"
                    alt="About"
                    style={{
                      willChange: "transform",
                      transform:
                        "perspective(1000px) rotateX(0deg) rotateY(0deg)",
                      width: "400px",
                      height: "350px",
                      objectFit: "cover",
                    }}
                  />
                </div>
                {/* <div className="img3">
                  <img
                    src="https://html.themeholy.com/rasm/demo/assets/img/shape/flower_1_3.png"
                    alt="About"
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="overflow-hidden space-top"
        data-pos-for=".choose-area2"
        data-sec-pos="bottom-half"
        style={{ marginBottom: "-100px", paddingTop: "40px" }}
      >
        <div className="container">
          <div className="counter-sec style4 space-top">
            <h4 className="about-us-visionss">Our Vision</h4>
            <p>
              At Surgery Saathi, our vision is to redefine patient care in
              cosmetic surgery, creating a supportive and trusted environment
              where every individual feels empowered in their journey. We are
              committed to providing personalized, high-quality surgical
              solutions by partnering with top surgeons and premier hospitals.
              Our goal is to be a leader in patient-centric care, offering
              excellence at every step—from consultation to recovery. We
              envision Surgery Saathi as not just a surgical center, but a
              trusted companion dedicated to helping patients achieve their
              goals with confidence and comfort.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionOne;
